export default {

  init(){

    setInterval(function(){

      $( document.body ).trigger( 'update_checkout' );

    }, 1000 * 60);

  },

  finalize(){



  },

};



// WEBPACK FOOTER //
// ./scripts/routes/woocommercecheckout.js